function isRecord(item) {
    return item != null && !Array.isArray(item) && typeof item === 'object';
}
function getGlobal(path = '') {
    const value = path
        .replace(/^window.guardian./, '')
        .replace(/\[(.+?)\]/g, '.$1')
        .split('.')
        .reduce((config, key) => {
        if (isRecord(config)) {
            return config[key];
        }
        return config;
    }, window.guardian);
    if (value) {
        return value;
    }
    return null;
}
const emptyAmountsTestVariants = [
    {
        variantName: 'CONTROL',
        defaultContributionType: 'MONTHLY',
        displayContributionType: ['ONE_OFF', 'MONTHLY', 'ANNUAL'],
        amountsCardData: {
            ONE_OFF: {
                amounts: [],
                defaultAmount: 0,
                hideChooseYourAmount: false,
            },
            MONTHLY: {
                amounts: [],
                defaultAmount: 0,
                hideChooseYourAmount: false,
            },
            ANNUAL: {
                amounts: [],
                defaultAmount: 0,
                hideChooseYourAmount: false,
            },
        },
    },
];
export const emptyConfiguredRegionAmounts = {
    testName: '',
    liveTestName: '',
    isLive: false,
    targeting: {
        targetingType: 'Region',
        region: 'GBPCountries',
    },
    order: 0,
    seed: 0,
    variants: emptyAmountsTestVariants,
};
export const emptySwitches = {
    experiments: {},
    oneOffPaymentMethods: {},
    recurringPaymentMethods: {},
    subscriptionsPaymentMethods: {},
    subscriptionsSwitches: {},
    featureSwitches: {},
    campaignSwitches: {},
    recaptchaSwitches: {},
};
const getSettings = () => {
    const globalSettings = getGlobal('settings');
    const defaultSettings = {
        switches: emptySwitches,
        amounts: [
            {
                ...emptyConfiguredRegionAmounts,
                testName: 'EMPTY_TEST__GBPCountries',
                target: 'GBPCountries',
            },
            {
                ...emptyConfiguredRegionAmounts,
                testName: 'EMPTY_TEST__UnitedStates',
                target: 'UnitedStates',
            },
            {
                ...emptyConfiguredRegionAmounts,
                testName: 'EMPTY_TEST__Canada',
                target: 'Canada',
            },
            {
                ...emptyConfiguredRegionAmounts,
                testName: 'EMPTY_TEST__NZDCountries',
                target: 'NZDCountries',
            },
            {
                ...emptyConfiguredRegionAmounts,
                testName: 'EMPTY_TEST__EURCountries',
                target: 'EURCountries',
            },
            {
                ...emptyConfiguredRegionAmounts,
                testName: 'EMPTY_TEST__International',
                target: 'International',
            },
            {
                ...emptyConfiguredRegionAmounts,
                testName: 'EMPTY_TEST__AUDCountries',
                target: 'AUDCountries',
            },
        ],
        contributionTypes: {
            GBPCountries: [],
            UnitedStates: [],
            EURCountries: [],
            AUDCountries: [],
            International: [],
            NZDCountries: [],
            Canada: [],
        },
        metricUrl: '',
    };
    return globalSettings ?? defaultSettings;
};
const getProductPrices = () => getGlobal('productPrices');
const getPromotionCopy = () => getGlobal('promotionCopy');
const isSwitchOn = (switchName) => {
    const sw = getGlobal(`settings.switches.${switchName}`);
    return !!(sw && sw === 'On');
};
export { getProductPrices, getPromotionCopy, getGlobal, getSettings, isSwitchOn, };
